import { environment } from 'src/environments/environment';
import config from './config';
import { SchoolConfigInterface } from '../../interfaces';

export const schoolConfig: SchoolConfigInterface =
  environment.SCHOOL_CONFIG_NAME in config
    ? config[environment.SCHOOL_CONFIG_NAME]
    : config[environment.DEFAULT_CONFIG_NAME];
